import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=028e4663&scoped=true"
import script from "./menu.vue?vue&type=script&setup=true&lang=js"
export * from "./menu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=028e4663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e4663",
  null
  
)

export default component.exports